// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1D4B5","productName":"Table_productName__AGJyT"};